
<template>
  <!-- 我的菜单管理 -->
  <div chass="app-container">
    <div class="chart-container">
      <el-row :gutter="20">
        <el-col :span="24" style="margin-bottom:20px;background:#fff">
          <div class="grid-content" style="float: left;width: 100%;position:relative;">
            <div class="ibox-title" style="float: left;width: 100%;">
              <span style="float:left;">
                <h5>我的菜单管理</h5>
              </span>
            </div>
            <div v-if="tableData.length > 0">
              <el-button slot="reference" size="mini" icon="el-icon-circle-plus-outline" @click="adddivshow" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px">添加</el-button>
              <el-table :data="tableData.slice((currentPage-1)*sizePage,currentPage*sizePage)" class="tb-edit" height="500" style border row-key="id" :tree-props="{children: 'childMenus', hasChildren: 'hasChildren'}">
                <el-table-column prop="name" label="菜单名">
                </el-table-column>
                <el-table-column label="操作" width="300">
                  <template slot-scope="scope">
                    <el-button size="mini" type="danger" style="float:right" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    <el-button size="mini" type="primary" style="float:right;margin-right:10px" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button size="mini" type="success" style="float:right" v-if="scope.row.yiji" @click="addzimenu(scope.$index, scope.row)">添加子菜单</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="block">
                <el-pagination :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="sizePage" layout="->,total,sizes,  prev, pager, next, jumper" :pager-count="5" :total="dataLength"
                  style="margin-top:10px;" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
              </div>
            </div>

            <el-dialog title="子菜单列表" :visible.sync="dialogTableVisible">
              <el-table :data="gridDatazimenu.slice((currentzimenuPage-1)*sizezimenuPage,currentzimenuPage*sizezimenuPage)">
                <el-table-column prop="name" label="菜单名"></el-table-column>
                <el-table-column label="操作" width="250">
                  <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="handleEditzimenu(scope.$index, scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDeletezimenu(scope.$index, scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="block">
                <el-pagination :current-page="currentzimenuPage" :page-sizes="[10, 20, 30, 50]" :page-size="sizezimenuPage" layout="->,total,sizes,  prev, pager, next, jumper" :pager-count="5" :total="datazimenuLength"
                  style="margin-top:10px;" @size-change="handleSizeChangezimenu" @current-change="handleCurrentChangezimenu" />
              </div>
            </el-dialog>

            <div v-if="tableData.length==0" style="position: relative">
              <div class="wubaobiao">
                <div>
                  <svg-icon slot="reference" icon-class="zhuangxiang" class="icon" style="width:100px;height:100px;color:#1890ff;margin-top:10px" />
                </div>
                <div style="margin-top:10px;font-size:14px">尚未添加菜单</div>
                <el-button @click="adddivif = true" slot="reference" size="mini" style="margin-top:10px" icon="el-icon-circle-plus-outline">添加</el-button>
              </div>
            </div>

          </div>
        </el-col>
      </el-row>

      <div class="tianjiastyle" v-show="adddivif">
        <div class="tianjiastyle_bg"></div>
        <div class="tianjiastyle_content">
          <el-form ref="form" :inline="true" :model="form" label-width="100px">
            <el-form-item label="菜单名">
              <el-input v-model="form.name" style="width:200px"></el-input>
            </el-form-item>
            <!-- <el-form-item label="菜单说明">
              <el-input v-model="form.name" style="width:200px"></el-input>
            </el-form-item> -->
            <el-form-item>
              <el-button type="primary" @click="onSubmit">保存</el-button>
              <el-button @click="hidedivshow">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {
  ajax_removemenu,
  ajax_addmenu,
  ajax_mymenulist,
  ajax_mymenulistfu
} from "@Gms~/api/ajax_model";


export default {
  name: "addmenu",
  components: {},
  data() {
    const generateData = _ => {
      const data = [];
      const cities = [
      ];
      const pinyin = [
      ];
      cities.forEach((city, index) => {
        data.push({
          label: city,
          key: index,
          cities: cities[index]
        });
      });
      return data;
    };
    return {
      data: generateData(),
      value: [1, 4],
      filterMethod(query, item) {
        return item.cities.indexOf(query) > -1;
      },
      form: {
        id: "",
        name: "",
        desc: ""
      },
      adddivif: false,
      eventdivif: false,
      platformTypes: "",
      tableData: [],
      tableDatacopy: [],
      currentPage: 1,
      dataLength: 1,
      sizePage: 20,
      datazimenuLength: 1,
      currentzimenuPage: 1,
      sizezimenuPage: 10,

      fid: "",
      dialogTableVisible: false,
      gridDatazimenu: []
    };
  },
  created() {
    this.getEventsfn();
  },
  mounted() { },
  methods: {
    getEventsfn() {
      ajax_mymenulistfu().then(
        response => {
          console.log("菜单管理", response);
          if (response.code == 1) {
            this.tableData = response.data;
            for (var i = 0; i < this.tableData.length; i++) {
              // hasChildren: true
              if (this.tableData[i].childMenus > 0) {
                this.tableData[i].hasChildren = true;
              }
              this.tableData[i].yiji = true;
            }
            this.tableDatacopy = response.data;
            this.dataLength = response.data.length;
          }
        }
      );
    },
    handleEdit(index, row) {
      console.log(index, row);
      this.adddivif = true;
      this.form.id = row.id;
      this.form.name = row.name;
      this.fid = "";
    },
    addzimenu(index, row) {
      this.fid = row.id;
      this.form.id = "";
      this.form.name = "";
      this.adddivif = true;
    },
    handleDelete(index, row) {
      this.fid = "";
      console.log(index, row);
      this.$confirm("此操作将永久删除该菜单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          ajax_removemenu(
            row.id,
          ).then(response => {
            console.log(response);
            if (response.code == 1) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.initmenu();
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
    handleEditzimenu(index, row) {
      console.log(index, row);
      this.adddivif = true;
      this.form.id = row.id;
      this.form.name = row.name;
    },
    handleDeletezimenu(index, row) {
      console.log(index, row);
      this.$confirm("此操作将永久删除该菜单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          ajax_removemenu(
            row.id,
          ).then(response => {
            console.log(response);
            if (response.code == 1) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.initmenu();
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
    formatter(row, column) {
      return row.address;
    },
    filterTag(value, row) {
      console.log(value);
      return row.delFlag === value;
    },
    filterTagdataType(value, row) {
      return row.dataType === value;
    },
    filterTagdelFlag(value, row) {
      return row.delFlag === value;
    },
    filterTagispreset(value, row) {
      return row.ispreset === value;
    },
    eventshaixuan(e) {
      this.platformTypes = e;
      this.getEventsfn(this.platformTypes);
    },

    handleChange(value, direction, movedKeys) {
      console.log(value, direction, movedKeys);
    },
    onSubmit() {
      ajax_addmenu(
        this.form.id,
        this.form.name,
        this.fid
      ).then(response => {
        console.log(response);
        if (response.code == 1) {
          this.adddivif = false;
          this.initmenu();
        }
      });
    },
    initmenu() {
        // 重新获取路由
      this.$store.dispatch('permission/generateRoutesInfo').then(res => { 
          this.$router.addRoutes(res)
      })
      this.getEventsfn();
      
    },
    
    adddivshow() {
      this.fid = "";
      this.form.id = "";
      this.form.name = "";
      this.adddivif = true;
    },
    hidedivshow() {
      this.adddivif = false;
    },
    hideeventdiv() {
      this.eventdivif = false;
    },
    handleSizeChange(e) {
      // table 分页数量变化
      this.sizePage = e;
    },
    handleCurrentChange(e) {
      // table 分页变化
      this.currentPage = e;
    },
    handleSizeChangezimenu(e) {
      // table 分页数量变化
      this.sizezimenuPage = e;
    },
    handleCurrentChangezimenu(e) {
      // table 分页变化
      this.currentzimenuPage = e;
    }
  },
  filters: {
    delFlags(value) {
      if (value == "0") {
        return "显示";
      } else if (value == "1") {
        return "隐藏";
      }
    },
    platformTypes(value) {
      if (value == "1") {
        return "服务端事件";
      } else if (value == "2") {
        return "客户端事件";
      }
    },
    dataTypes(value) {
      // 1：文本 2：Long 3：Double 4：json 5：布尔
      if (value == "1") {
        return "文本";
      } else if (value == "2") {
        return "Long";
      } else if (value == "3") {
        return "Double";
      } else if (value == "4") {
        return "JSON";
      } else if (value == "5") {
        return "布尔";
      }
    },
    ispresets(value) {
      if (value == "0") {
        return "否";
      } else if (value == "1") {
        return "是";
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-container {
  background-color: #364652;
}
.chart-container {
  position: relative;
  padding: 10px 15px;
  padding-bottom: 1px;
  /* width: 100%;
    height: 30%; */
  background-color: #f0efef;
}
.ibox-title {
  line-height: 32px;
  padding: 8px 15px 7px;
}

/* .grid-content  */
.ibox-title {
  border-bottom: 1px solid #dedede;
}
.ibox-content {
  border: none;
}
.ibox-title h5 {
  margin: 0;
}
.tb-edit {
  width: 98%;
  margin-left: 1%;
  margin-top: 15px;
}
/* .el-table th{background:#fff;} */
</style>

<style>
.el-tabs__header {
  margin-bottom: 0px;
}
.el-tabs__nav {
  /* margin-left: 30px;
  margin-right: 30px; */
}
.el-row {
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #fff;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 30px;
  /* padding-bottom: 15px; */
}
.row-bg {
  /* padding: 10px 0; */
  background-color: #f9fafc;
}
.el-table--medium td,
.el-table--medium th {
  padding: 6px;
}
.el-table th {
  background-color: #fff;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.panel-group {
  // margin-top: 18px;
  .card-panel-col {
    // margin-bottom: 32px;
  }
  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.1);
    border-color: rgba(0, 0, 0, 0.05);
    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }
      .icon-people {
        background: #40c9c6;
      }
      .icon-message {
        background: #36a3f7;
      }
      .icon-money {
        background: #f4516c;
      }
      .icon-shoppingCard {
        background: #34bfa3;
      }
    }
    .icon-people {
      color: #40c9c6;
    }
    .icon-message {
      color: #36a3f7;
    }
    .icon-money {
      color: #f4516c;
    }
    .icon-shoppingCard {
      color: #34bfa3;
    }
    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }
    .card-panel-icon {
      float: left;
      font-size: 48px;
    }
    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }
      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}
</style>
<style>
.aaa {
  text-align: center;
}
.shishitophuizong {
  width: 16.6%;
  float: left;
  text-align: center;
}
.shishitophuizong1 {
  font-size: 14px;
  font-weight: 600;
  padding: 5px 0px;
}
.shishitophuizong2 {
  font-size: 30px;
  font-weight: 100;
  padding: 5px 0px;
}
.shishitophuizong3 {
  font-size: 12px;
  font-weight: 100;
  padding: 5px 0px;
}
.shishitophuizong1 icon {
  width: 15px;
  height: 15px;
}

.shishitophuizonger {
  width: 16.6%;
  float: left;
  text-align: center;
  border-top: 1px solid #e7eaec;
  padding: 8px 0px;
  vertical-align: middle;
  color: #337ab7;
  font-size: 14px;
}
.el-tag {
  background: none;
  border: none;
}

.zhibiaoshuoming {
  font-size: 12px;
  color: #999;
}
.zhibiaoshuoming_title {
  font-size: 14px;
  color: #666;
  display: block;
  border-bottom: 1px solid #dedede;
  padding-bottom: 10px;
}
.el-loading-mask {
  z-index: 5;
}
.disqudao {
  display: none;
}

.tianjiastyle {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 6666;
}
.tianjiastyle_bg {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
}
.tianjiastyle_content {
  width: 600px;
  background: #fff;
  padding: 20px;
  position: absolute;
  top: 50px;
  left: 50%;
  margin-left: -470px;
  border: 1px solid #dedede;
}
.wubaobiao {
  width: 300px;
  height: 200px;
  text-align: center;
  background: #fff;
  margin-bottom: 600px;
  color: #1890ff;
  position: relative;
  left: 50%;
  margin-left: -150px;
  top: 150px;
}
</style>